import { render, staticRenderFns } from "./EditorMention.vue?vue&type=template&id=29db4006&"
import script from "./EditorMention.vue?vue&type=script&lang=js&"
export * from "./EditorMention.vue?vue&type=script&lang=js&"
import style0 from "./EditorMention.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports